import { useEffect, useRef, useState } from "react";
import JsBarcode from "jsbarcode";
import { useLocation } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall } from "../CommonComponents/CustomHooks";
const LabelPrint = ({ menuText }) => {

    const location = useLocation();
    const dispatch = useDispatch();
    const searchParams = new URLSearchParams(location.search);
    const headerTrackingNumber = searchParams.get('awbNumber');


    const [data, setData] = useState({});

    const handlePrintData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Operation/PrintAwbNoLabel', { AwbNo: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, null, null);
            setData({})
        }
        else {
            let record = editData.data
            setData(record)
        }

    }


    function BarcodeDisplay({ value, width = 1.5, height = 50 }) {
        const svgRef = useRef(null);

        useEffect(() => {
            if (svgRef.current && value) {
                JsBarcode(svgRef.current, value, {
                    format: "CODE128",
                    width: width,
                    height: height,
                    displayValue: true,
                    fontSize: 12,
                    margin: 2
                });
            }
        }, [value, width, height]);

        if (!value) return null;
        return <svg ref={svgRef}></svg>;
    }

    const handlePrint = () => {
        window.print();
    };


    useEffect(() => {
        if (headerTrackingNumber) {
           
            handlePrintData(headerTrackingNumber)
        }
    }, [headerTrackingNumber]);

    if (!data) return null;


 

    return (
        <>
            <div>
                {/* PRINT CSS */}
                <style>{`
                @media print {
                    body * { visibility: hidden; }
                    #printArea, #printArea * { visibility: visible; }
                    #printArea {
                        position: absolute;
                        top: 0;
                        width: 210mm;
                        padding: 12mm;
                        background: white;
                    }
                    /* ✅ Button print mein nahi aayega */
                    #printBtn { display: none; }
                }
                @page {
                    size: A4;
                    margin: 0;
                }
            `}</style>

                {/* ✅ PRINT BUTTON */}
                <div id="printBtn" style={styles.printBtnContainer}>
                    <button onClick={handlePrint} style={styles.printButton}>
                        🖨️ Print Shipment
                    </button>
                </div>

                <div id="printArea" style={styles.page}>

                    {/* HEADER */}
                    <div style={styles.header}>
                        <img src="./assets/img/mainlogo.png" style={styles.logo} alt="logo" />
                        <div style={styles.companyName}>
                            {data.company?.name || ""}
                        </div>
                    </div>

                    <div style={styles.companyInfo}>
                        {data.company?.addressLine1 || ""}<br />
                        {data.company?.addressLine2 || ""}<br />
                        Tel No : {data.company?.phone || ""}<br />
                        E-Mail : {data.company?.email || ""}
                    </div>

                    <div style={styles.blueLine} />

                    {/* BOOKING */}
                    <div style={styles.bookingGrid}>
                        <div>
                            <p><span style={styles.label}>Booking Date :</span> {data.booking?.date || ""}</p>
                            <p><span style={styles.label}>Origin :</span> {data.booking?.origin || ""}</p>
                            <p><span style={styles.label}>Destination :</span> {data.booking?.destination || ""}</p>
                            <p><span style={styles.label}>Product Description :</span></p>
                        </div>
                        <div>
                            <p><span style={styles.label}>Payment :</span> {data.booking?.payment || ""}</p>
                            <p><span style={styles.label}>Pieces :</span> {data.booking?.pieces || ""}</p>
                            <p><span style={styles.label}>Weight :</span> {data.booking?.weight || ""}</p>
                            <p><span style={styles.label}>Invoice Value :</span> {data.booking?.invoiceValue || ""}</p>
                        </div>
                    </div>

                    <div style={styles.blueLine} />

                    {/* SHIPPER */}
                    <div>
                        <div style={styles.sectionTitle}>Shipper -</div>
                        <p><span style={styles.label}>Name :</span> {data.shipper?.name || ""}</p>
                        <p><span style={styles.label}>Company Address :</span> {data.shipper?.address || ""}</p>
                        <p><span style={styles.label}>City :</span> {data.shipper?.city || ""}</p>
                        <p><span style={styles.label}>Country :</span> {data.shipper?.country || ""}</p>
                        <p><span style={styles.label}>Zip Code :</span> {data.shipper?.zip || ""}</p>
                        <p><span style={styles.label}>Phone :</span> {data.shipper?.phone || ""}</p>
                        <p><span style={styles.label}>E-Mail :</span> {data.shipper?.email || ""}</p>
                    </div>

                    <div style={styles.blueLine} />

                    {/* CONSIGNEE */}
                    <div>
                        <div style={styles.sectionTitle}>Consignee -</div>
                        <p><span style={styles.label}>Name :</span> {data.consignee?.name || ""}</p>
                        <p><span style={styles.label}>Company Address :</span> {data.consignee?.address || ""}</p>
                        <p><span style={styles.label}>City :</span> {data.consignee?.city || ""}</p>
                        <p><span style={styles.label}>Country :</span> {data.consignee?.country || ""}</p>
                        <p><span style={styles.label}>Zip Code :</span> {data.consignee?.zip || ""}</p>
                        <p><span style={styles.label}></span> {data.consignee?.phone || ""}</p>
                        <p><span style={styles.label}></span> {data.consignee?.email || ""}</p>
                    </div>

                    <div style={styles.blueLine} />

                    {/* BARCODES */}
                    <div style={{ textAlign: "center" }}>
                        <div style={styles?.barcodeTitle}>{data.shipment?.reference}</div>
                        <BarcodeDisplay value={data?.shipment?.reference} width={1.5} height={50} />

                        <div style={{ marginTop: 16, ...styles.barcodeTitle }}>{data.shipment?.awb}</div>
                        <BarcodeDisplay value={data?.shipment?.awb} width={2} height={70} />
                    </div>

                </div>
            </div> 

        </>
    )
}

export default LabelPrint;

const styles = {
    // ✅ New styles
    printBtnContainer: {
        display: "flex",
        justifyContent: "flex-end",
        padding: "10px 20px",
        background: "#f5f5f5",
        borderBottom: "1px solid #ddd"
    },
    printButton: {
        padding: "10px 24px",
        backgroundColor: "#1a56db",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: "500",
        cursor: "pointer"
    },

    page: {
        width: "210mm",
        minHeight: "297mm",
        fontFamily: "Arial",
        fontSize: 11,
        margin: "auto",
        color: "#000"
    },
    header: {
        textAlign: "center",
        position: "relative"
    },
    logo: {
        height: 40,
        position: "absolute",
        left: 20,
        top: 0
    },
    companyName: {
        fontSize: 18,
        fontWeight: "bold"
    },
    companyInfo: {
        textAlign: "center",
        fontSize: 10,
        marginTop: 5
    },
    blueLine: {
        borderBottom: "2px solid blue",
        margin: "8px 0"
    },
    bookingGrid: {
        display: "flex",
        justifyContent: "space-between"
    },
    sectionTitle: {
        color: "red",
        fontWeight: "bold",
        marginBottom: 5
    },
    label: {
        color: "blue",
        fontWeight: 500
    },
    barcodeTitle: {
        fontWeight: "bold",
        marginBottom: 5
    }
};